const React = require("react");

function ApplicationHeader() {
  return (
    <div className="application-header">
      <h1>React Example To-Do App</h1>
    </div>
  );
}

module.exports = ApplicationHeader;
